// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import ModalCreateOrUpdateDownloadCode from '../modals/createOrUpdateDownloadCode/ModalCreateOrUpdateDownloadCode';
import Dropdown from '@/common-utils/components/renders/dropdown/Dropdown';
// Common
import ICONS from '@/common-utils/enums/icons';
import Permissions from '@/app/permissions/Permissions';
// Lang
import { nsEnvelope } from '@/app/i18n/namespaces';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

/**
 *
 * @param root0
 * @param root0.downloadCode
 * @returns {JSX} DropdownDownloadCodeActionsRow
 */
function DropdownDownloadCodeActionsRow({ downloadCode }) {
    // Store
    const permissions = useSessionStore(s => s.session.permissions);

    //State
    const [showModalUpdateDownloadCode, setShowModalUpdateDownloadCode] = useState(false);

    //Functions
    const handleShowModalUpdateLabel = () => {
        setShowModalUpdateDownloadCode(true);
    };

    return (
        <>
            <Dropdown
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                dataCy='download-codes-actions-dropdown-row'
                actions={[
                    {
                        icon: ICONS.EDIT,
                        entity: 'actions.row.update_download_code',
                        namespace: nsEnvelope,
                        onClick: handleShowModalUpdateLabel,
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.CSV_INSERT_POS_REMOTE_DOWNLOAD.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    }
                ]} />
            {
                showModalUpdateDownloadCode &&
                <ModalCreateOrUpdateDownloadCode
                    isOpen={showModalUpdateDownloadCode}
                    setIsOpen={setShowModalUpdateDownloadCode}
                    downloadCode={downloadCode}
                />
            }
        </>
    );
}

DropdownDownloadCodeActionsRow.propTypes = {
    downloadCode: PropTypes.object.isRequired
};

export default DropdownDownloadCodeActionsRow;